import state from './moduleCrewTierState.js'
import mutations from './moduleCrewTierMutations.js'
import actions from './moduleCrewTierActions.js'
import getters from './moduleCrewTierGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
